import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_81kagp61wy: FaireBrandEntity = {
  token: "b_81kagp61wy",
  type: "brand",
  name: "HABA USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/874e7d80207ba37453ea011615ea16f2ed2fb7454e6225a9a4a3314205a38220.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/88b8714feaf2405d3dd2b4966ea4677e00af9b6ec9158afabfd3cd62e4362f11.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/874e7d80207ba37453ea011615ea16f2ed2fb7454e6225a9a4a3314205a38220.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/88b8714feaf2405d3dd2b4966ea4677e00af9b6ec9158afabfd3cd62e4362f11.jpeg",
  location: "Skaneateles, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 249,
  isTopShop: true,
  isInsider: true,
  description:
    "Toys for Kids that Spark Imaginative Play\nIn the world of HABA, play reigns, eyes dance, and the sound of giggles can be heard everywhere.\nHABA’s European-designed, sustainable kids toys and games open up curiosity and wonder and pull families deep into the world of imagination. From wooden blocks to preschool toys, board games to timeless dolls, HABA believes life is better when we all play together.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:53.766Z",
    importedBy: "entity-db-cli",
  },
};
